import { forwardRef, type ButtonHTMLAttributes } from "react";

export const IconButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & { appearance?: "default" | "dialog" }>(function IconButton({ className = "", type = "button", appearance = "default", ...props }, ref) {
  return <button ref={ref} className={`${appearance === "dialog" ? "btn icon" : "icon-button"} ${className}`.trim()} type={type} {...props} />;
});
